import React from 'react'
import { component_tool } from '@/tool'
import { WizTableForm } from '../../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'businessId',
            name: 'businessId',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'delFlag',
            name: 'delFlag',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: '组织名称',
            name: 'name',
            searchItem: {},
            tableItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入组织名称'
                }],
            }
        },
        {
            title: '组织编码',
            name: 'code',
            searchItem: {},
            tableItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入组织编码'
                }],
            }
        },
        {
            title: '组织类型',
            name: 'organizationNodeCategoryName',
            tableItem: {},
         //   dict:self.props.nodeCategorySelect.data,// self.props.typeNodeList
            // formItem: {
            //     type: 'select',
            //   },
        },
        
        {
            title: '组织状态',
            name: "state",
            dict: [
                { code: 1, codeName: "有效" },
                { code: 0, codeName: "无效" }
            ],
            tableItem: {},
            searchItem: {
                type: 'select'
            },
            formItem: {
              type: "select",
              initialValue: 1
            }
        },
        
    ]
}